import { Check as CheckIcon, Cog as SettingsIcon } from '@opengov/react-capital-assets';

import { Box, Card, CardActionArea, CardContent, SvgIcon, Typography } from '@mui/material';
import React from 'react';

import { ProductIcon } from '../../Components/icons/products/ProductIcon';
import { DATA_TEST, getDynamicDataTestId } from '../../enums';
import { IProductDetails, MUI_PRODUCT_ICONS, PRODUCT_ICONS } from '../../types';

interface IAppSwitcherSelectionCardProps {
  appDetails: IProductDetails;
  selected?: boolean;
  fullScreen?: boolean;
  onClick(product: IProductDetails): void;
}

export const IconRenderer = (appDetails: IProductDetails) => {
  const isAdminApp = appDetails?.entitlementProductKey === MUI_PRODUCT_ICONS.adminsettings;

  if (isAdminApp) {
    return <SettingsIcon data-test={DATA_TEST.admin_settings_icon} />;
  }
  return <ProductIcon icon={PRODUCT_ICONS[appDetails?.entitlementProductKey]} />;
};

export const AppSwitcherSelectionCard: React.FC<IAppSwitcherSelectionCardProps> = ({
  appDetails,
  selected,
  fullScreen,
  onClick
}) => {
  return (
    <Box>
      <CardActionArea
        data-test={getDynamicDataTestId(DATA_TEST.app_switcher_selection_dialog_card, appDetails.entitlementProductKey)}
        sx={{
          height: '100%',
          // Override the default MUI card action area hover color
          '&:hover .MuiCard-root': {
            backgroundColor: (theme: any) => `${theme.palette.action.selected} !important`
          }
        }}
        onClick={() => {
          onClick(appDetails);
        }}
      >
        <Card
          sx={{
            borderRadius: 2,
            height: '100%',
            ...(!fullScreen && { maxWidth: 250 }),
            ...(selected && { borderColor: 'primary.main' })
          }}
        >
          <CardContent>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Box sx={{ height: '100%', mt: 0.5, color: 'primary.main' }}>
                <SvgIcon
                  viewBox="0 0 16 16"
                  sx={{
                    svg: {
                      fill: 'primary.main'
                    },
                    fontSize: '20px'
                  }}
                >
                  {selected && <CheckIcon data-test={DATA_TEST.app_switcher_selection_dialog_card_check_icon} />}
                  {!selected && <IconRenderer {...appDetails} />}
                </SvgIcon>
              </Box>
              <Box sx={{ height: '100%' }}>
                <Typography variant="h5" fontWeight="bold" sx={{ color: 'primary.main' }}>
                  {appDetails?.displayName}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.primary' }}>
                  {appDetails?.description}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </CardActionArea>
    </Box>
  );
};
